import { render, staticRenderFns } from "./rekonarkr.vue?vue&type=template&id=51808486&scoped=true"
import script from "./rekonarkr.vue?vue&type=script&lang=js"
export * from "./rekonarkr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51808486",
  null
  
)

export default component.exports